import React, { FC } from "react";

import { BaseModal } from "@/shared/ui";

interface RouteSwapWarningModalProps {
    onClose: () => void;
    onConfirm: () => void;
}

export const RouteSwapWarningModal: FC<RouteSwapWarningModalProps> = ({
    onClose,
    onConfirm,
}) => {
    return (
        <BaseModal
            open
            title="Попередження"
            onClose={onClose}
            description="У обох виконавців вже є призначені маршрути. Якщо ви продовжите, їхні маршрути поміняються місцями."
            onConfirm={onConfirm}
        />
    );
};
